import React from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import {
	containerStyle,
	imgContainer,
	imgStyle,
	paperStyle,
} from "./formStyle";
import { Assignment, PersonAdd, SummarizeOutlined } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { amber, headingBlue, maroon, mediumGrey, orange, pureWhite, yellowish } from "../assets/colors";
import HeaderBar from "../components/HeaderBar";
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import { getMemCardStatus } from "../backend/backendApis";
import HttpService from "../backend/requestApis";
import Memcard from "./membershipCard/memcard";
import UpdateWORKerDetails from "./WORKersManagement/UpdateWORKersDetails/updateWORKerDetails";
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import WORKersHeadsDiaog from "./WORKer'sHeads/WORKer'sHeadsDiaog";
import VolunteeringDomainDialog from "./WORKersManagement/contributionFields/VolunteeringDomainDialog";
import WORKersLeadManagement from "./WORKersLead/WORKersLeadManagement";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import SchoolIcon from '@mui/icons-material/School';

var rowStyle = {
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	color: headingBlue,
	curser: "pointer",
	padding: "0.5rem 0.2rem 0.2rem 0.2rem",
};

const ReportForms = () => {

	const [userIconStatus, setUserIconStatus] = useState(false)
	const [loader, setLoader] = useState(false)
	const [updateWORKerDetailsDialogStatus, setUpdateWORKerDetailsDialogStatus] = useState(false)
	const [memcardDialogStatus, setMemCardDialogStatus] = useState(false)
	const [chapterCode, setChapterCode] = useState(null)
	const [name, setName] = useState(null)
	const [id, setId] = useState(null)
	const [photoStatus, setPhotoStatus] = useState(null)
	const [gender, setGender] = useState(null)
	const [obligation, setObligation] = useState('WORKer')

	const [headsDetailsDialogStaus, setHeadsDetailsDialogStatus] = useState(false)
	const [volunteeringDomainDialog, setVolunteeringDomainDialog] = useState(false)

	const navigate = useNavigate();

	React.useEffect(() => {
		let token = localStorage.getItem("token");
		if (!token) {
			navigate("/signUp");
		}
	}, []);
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

	useEffect(() => {
		const handleResize = () => setIsMobile(window.innerWidth <= 768);
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	useEffect(() => {
		try{
			if(userIconStatus && localStorage.getItem('contact')){
				setLoader(true)
				let options = {
					url: getMemCardStatus,
					method: 'GET',
					params: {
						// if ContactNumber is not present navigate to sigin.
						contactNumber: localStorage.getItem('contact')
					},
					headers: {
                        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
                    }
				}
				HttpService(options).then(resp => {
					// setMemCardStatus(resp?.data?.data?.isMemCardGenerated)
					if(resp?.data?.data?.isMemCardGenerated) {
						setName(resp?.data?.data?.name)
						setChapterCode(resp?.data?.data?.chapterCode)
						setId(resp?.data?.data?.id)
						setPhotoStatus(resp?.data?.data?.photoStatus)
						setMemCardDialogStatus(true)
						setObligation(resp?.data?.data?.obligation)
					} else {
						setGender(resp?.data?.data?.gender)
						setId(resp?.data?.data?.id)
						setChapterCode(resp?.data?.data?.chapterCode)
						setPhotoStatus(resp?.data?.data?.photoStatus)
						setUpdateWORKerDetailsDialogStatus(true)
					}
					setLoader(false)
				}).catch(err => { 
					setLoader(false)
					if (err?.status === 403) {
						localStorage.clear();
						// setLoadingTableData(false);
						navigate("/signUp");
					  } else {
							console.log('Error in getting mem card Status: ', err)
					  }
					
				})
			} else {
				if(!localStorage.getItem('contact')){
					navigate('/signUp')
				}
			}
		} catch(err){
			setLoader(false)
			console.log('Error in checking mem card status: ', err)
		}
	}, [userIconStatus])

	useEffect(() => {
		let contact = localStorage.getItem('contact')
		let prefix = localStorage.getItem('prefix')
		let smp = localStorage.getItem('smp')
		if( !contact || !prefix || !smp){
			localStorage.clear()
			navigate('/signUp')
		}
	}, [])

	const gridColumnStyle = isMobile ? "repeat(2, 1fr)" : "repeat(1, 1fr)";

	return (
		<>
			<HeaderBar isReportForm={true}></HeaderBar>
			<div style={{ ...containerStyle, maxWidth: "30rem" }}>
				<div style={{ ...imgContainer, padding: "0.4rem" }}>
					<img
						src={require("../assets/images/WORK_logo.png")}
						alt="Logo"
						style={{ ...imgStyle, cursor: "pointer" }}
						onClick={() => {
							localStorage.clear();
							navigate("/signUp");
						}}
					></img>
				</div>
				{/* <Box style={{padding: '0.4rem 0.1rem 0.2rem 0.1rem'}}>
					<Typography >
						<strong> Important Message For WORKers</strong>
					</Typography>
					<ul style={{marginTop: '0rem', marginLeft: '0rem', fontSize: '0.8rem', color: maroon}}>
						<li>This Year WORK will not participate in Baltaal Medical Camp. Due to security Concerns.</li>
					</ul>
				</Box> */}
					
				<Box style={{height: isMobile ? '65vh': '58vh', overflow:'auto', "&::-webkit-scrollbar":{
                    display: 'none'
                  },
                  scrollbarWidth: "none",
				  padding: '0.5rem 0.1rem 0.8rem 0.1rem'
				  }}>

					<Paper style={{padding: '0rem 0rem 0.2rem 0rem', marginTop: '0.5rem'}}>
						<Box style={{ borderRadius: '0.2.75rem 0.2.75rem 0rem 0rem', width: '100%', borderRadius: '0.3rem 0.3rem 0rem 0rem', backgroundColor: orange, color: pureWhite}}>
								<Typography style={{padding: '0.4rem 0.5rem 0.4rem 0.5rem'}}> <strong> WORKers Section  </strong></Typography>
							</Box>
						<Grid container spacing={1} style={{ padding: "0.5rem 1rem 0rem 1rem" }}>
							<Grid item xs={4} sm={3}>
								<div
										style={{ ...rowStyle, textAlign: "center" }}
										onClick={() => navigate("/WORKersTask")}
										onMouseOver={(e) => (e.currentTarget.style.color = maroon)}
										onMouseOut={(e) => (e.currentTarget.style.color = headingBlue)}
									>
										<Assignment sx={{ fontSize: "2.75rem" }}></Assignment>
										<Typography
											style={{
												fontSize: "1rem",
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
											}}
										>
											Tasks
										</Typography>
									</div>
								
							</Grid>

							<Grid item xs={4} sm={3}>
								<div
										style={{ ...rowStyle, textAlign: "center" }}
										onClick={() => navigate("/WORKersleads")}
										onMouseOver={(e) => (e.currentTarget.style.color = maroon)}
										onMouseOut={(e) => (e.currentTarget.style.color = headingBlue)}
									>
										<PersonAdd sx={{ fontSize: "2.75rem" }}/>
											<Typography
												style={{
													fontSize: "1rem",
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
												}}
											>
												Leads
										</Typography>
									</div>
								
							</Grid>

							<Grid item xs={4} sm={3}>
								<div
										style={{ ...rowStyle, textAlign: "center" }}
										onClick={() => navigate("/training")}
										onMouseOver={(e) => (e.currentTarget.style.color = maroon)}
										onMouseOut={(e) => (e.currentTarget.style.color = headingBlue)}
									>
										<SchoolIcon sx={{ fontSize: "2.75rem" }}/>
											<Typography
												style={{
													fontSize: "1rem",
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
												}}
											>
												Training
										</Typography>
									</div>
							</Grid>

							{localStorage.getItem('WORKerType') && ['nucleus', 'core'].includes(localStorage.getItem('WORKerType'))  &&
								<Grid item xs={4} sm={3}>
								<div
										style={{ ...rowStyle, textAlign: "center" }}
										onClick={() => navigate("/ask-allama")}
										onMouseOver={(e) => (e.currentTarget.style.color = maroon)}
										onMouseOut={(e) => (e.currentTarget.style.color = headingBlue)}
									>
										<AutoAwesomeIcon sx={{ fontSize: "2.75rem" }}/>
											<Typography
												style={{
													fontSize: "1rem",
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
												}}
											>
												Ask - Allama
										</Typography>
									</div>
								
								</Grid>}

							<Grid item xs={4} sm={3}>
								<div
										style={{ ...rowStyle, textAlign: "center" }}
										onClick={() => setUserIconStatus(true)}
										onMouseOver={(e) => (e.currentTarget.style.color = maroon)}
										onMouseOut={(e) => (e.currentTarget.style.color = headingBlue)}
									>
										<CardMembershipIcon sx={{ fontSize: "2.75rem" }}></CardMembershipIcon>
										<Typography
											style={{
												fontSize: "1rem",
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
											}}
										>
											Membership Card
										</Typography>
									</div>
								
							</Grid>

							<Grid item xs={4} sm={3}>
								<div
										style={{ ...rowStyle, textAlign: "center" }}
										onClick={() => setHeadsDetailsDialogStatus(true)}
										onMouseOver={(e) => (e.currentTarget.style.color = maroon)}
										onMouseOut={(e) => (e.currentTarget.style.color = headingBlue)}
									>
										<SupervisorAccountIcon sx={{ fontSize: "2.75rem" }}></SupervisorAccountIcon>
										<Typography
											style={{
												fontSize: "1rem",
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
											}}
										>
											Heads
										</Typography>
									</div>
								
							</Grid>

							<Grid item xs={4} sm={3}>
								<div
										style={{ ...rowStyle, textAlign: "center" }}
										onClick={() => setVolunteeringDomainDialog(true)}
										onMouseOver={(e) => (e.currentTarget.style.color = maroon)}
										onMouseOut={(e) => (e.currentTarget.style.color = headingBlue)}
									>
										<VolunteerActivismIcon sx={{ fontSize: "2.75rem" }}/>
										<Typography
											style={{
												fontSize: "1rem",
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
											}}
										>
											Volunteering Domain
										</Typography>
									</div>
								
							</Grid>

						</Grid>
					</Paper>

					{ localStorage.getItem('smp') && localStorage.getItem('smp') == 'true' &&
						<Paper
							style={{
								display: "flex",
								// gridTemplateColumns: gridColumnStyle,
								flexDirection: "column",
								alignItems: "center",
								padding: "0rem 0rem",
								marginTop: '0.5rem'
							}}
						>
							<Box style={{ borderRadius: '0.2.75rem 0.2.75rem 0rem 0rem', width: '100%', borderRadius: '0.3rem 0.3rem 0rem 0rem', backgroundColor: amber, color: pureWhite}}>
								<Typography style={{padding: '0.4rem 0.5rem 0.4rem 0.5rem'}}> <strong> Social Media Sharing Project </strong></Typography>
							</Box>
							<Grid
								container
								spacing={1}
								style={{ padding: "1rem 1rem 0rem 1rem" }}
							>
								<Grid item xs={6} sm={3}>
									<div
										style={{ ...rowStyle, textAlign: "center" }}
										onClick={() => navigate("/one-time-task")}
										onMouseOver={(e) => (e.currentTarget.style.color = maroon)}
										onMouseOut={(e) => (e.currentTarget.style.color = headingBlue)}
									>
										<SummarizeOutlined sx={{ fontSize: "4rem" }} />
										<Typography
											style={{
												fontSize: "1rem",
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
											}}
										>
											One Time Tasks{" "}
										</Typography>
									</div>
								</Grid>
								<Grid item xs={6} sm={3}>
									<div
										style={{ ...rowStyle, textAlign: "center" }}
										onClick={() => navigate("/daily-task")}
										onMouseOver={(e) => (e.currentTarget.style.color = maroon)}
										onMouseOut={(e) => (e.currentTarget.style.color = headingBlue)}
									>
										<SummarizeOutlined sx={{ fontSize: "4rem" }} />
										<Typography
											style={{
												fontSize: "1rem",
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
											}}
										>
											Daily Tasks{" "}
										</Typography>
									</div>
								</Grid>

								<Grid item xs={6} sm={3}>
									<div
										style={{ ...rowStyle, textAlign: "center" }}
										onClick={() => navigate("/weekly-task")}
										onMouseOver={(e) => (e.currentTarget.style.color = maroon)}
										onMouseOut={(e) => (e.currentTarget.style.color = headingBlue)}
									>
										<SummarizeOutlined sx={{ fontSize: "4rem" }} />
										<Typography
											style={{
												fontSize: "1rem",
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
											}}
										>
											Weekly Tasks{" "}
										</Typography>
									</div>
								</Grid>
								<Grid
									item
									xs={6}
									sm={2.4}
									// style={{ pointerEvents: "none", opacity: 0.5 }}
								>
									<div
										style={{ ...rowStyle, textAlign: "center" }}
										onClick={() => navigate("/monthly-task")}
										onMouseOver={(e) => (e.currentTarget.style.color = maroon)}
										onMouseOut={(e) => (e.currentTarget.style.color = headingBlue)}
									>
										<SummarizeOutlined sx={{ fontSize: "4rem" }} />
										<Typography
											style={{
												fontSize: "1rem",
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
											}}
										>
											Monthly Tasks{" "}
										</Typography>
									</div>
									{/* <div
									style={rowStyle}
									onClick={() => navigate("/weekly-task")}
									onMouseOver={(e) => (e.currentTarget.style.color = maroon)}
									onMouseOut={(e) => (e.currentTarget.style.color = headingBlue)}
								>
									<SummarizeOutlined sx={{ fontSize: '4rem' }} />
									<Typography style={{fontSize: '1rem'}}>Weekly Tasks</Typography>
								</div> */}
								</Grid>
								<Grid item xs={6} sm={3}>
									<div
										style={{ ...rowStyle, textAlign: "center" }}
										onClick={() => navigate("/leads")}
										onMouseOver={(e) => (e.currentTarget.style.color = maroon)}
										onMouseOut={(e) => (e.currentTarget.style.color = headingBlue)}
									>
										<SummarizeOutlined sx={{ fontSize: "4rem" }} />
										<Typography
											style={{
												fontSize: "1rem",
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
											}}
										>
											Leads
										</Typography>
									</div>
								</Grid>
								<Grid item xs={6} sm={3}>
									<div
										style={{ ...rowStyle, textAlign: "center" }}
										onClick={() => navigate("/missingTasks")}
										onMouseOver={(e) => (e.currentTarget.style.color = maroon)}
										onMouseOut={(e) => (e.currentTarget.style.color = headingBlue)}
									>
										<SummarizeOutlined sx={{ fontSize: "4rem" }} />
										<Typography
											style={{
												fontSize: "1rem",
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
											}}
										>
											Pending Tasks
										</Typography>
									</div>
								</Grid>
							</Grid>
						</Paper>
						}
				</Box>

			</div>
			<Memcard memcardDialogStatus={memcardDialogStatus} 
				updatememCardDialogStatus={() => {
					setMemCardDialogStatus(!memcardDialogStatus) 
					setUserIconStatus(() => false)
				}}
				name= {name}
				chapterCode={chapterCode}
				id={id}
				photoStatus={photoStatus}
				obligation={obligation}
				></Memcard>
			<UpdateWORKerDetails wORKerDetailsDialogStatus={updateWORKerDetailsDialogStatus} updateWORKerDetailsDialogStatusFunc={() => {
				setUpdateWORKerDetailsDialogStatus(!updateWORKerDetailsDialogStatus)
				setUserIconStatus( () => false)
				}}
				chapterCode={chapterCode}
				gender={gender}
				id={id}
				photoStatus={photoStatus}
				></UpdateWORKerDetails>
			<WORKersHeadsDiaog dialogStatus = {headsDetailsDialogStaus} updateDialog = {(value) =>setHeadsDetailsDialogStatus(value)}>

			</WORKersHeadsDiaog>
			<VolunteeringDomainDialog dialogStatus={volunteeringDomainDialog} updateDialogStatus = {(value) => setVolunteeringDomainDialog(value)}
			></VolunteeringDomainDialog>
		</>
	);
};

export default ReportForms;
